import React from "react";
import Image from "next/image";
import { Partner } from "../../../../types/partnerType";
import {
  getImageUrl,
  isValidImageUrl,
  getPlaceholderImage,
} from "@/utils/image";

interface PartnerCardProps {
  partner: Partner;
}

/**
 * PartnerCard Component
 * Displays a single partner's information including logo, name, and address
 */
const PartnerCard: React.FC<PartnerCardProps> = ({ partner }) => {
  // Get the processed image URL
  const processedImageUrl = getImageUrl(partner.img.url);

  // Determine the final image source
  const imageSrc = isValidImageUrl(processedImageUrl)
    ? processedImageUrl
    : getPlaceholderImage(128, 64, "Partner");

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg transition-shadow duration-300">
      {/* Logo Section */}
      <div className="flex justify-center items-center h-20 mb-4">
        <div className="relative w-32 h-16">
          <Image
            src={imageSrc}
            alt={partner.img.alt || partner.name || "Partner logo"}
            fill
            className="object-contain"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </div>
      </div>

      {/* Partner Name */}
      <h3 className="text-lg font-semibold text-gray-800 text-center mb-3">
        {partner.name}
      </h3>

      {/* Address */}
      <p className="text-sm text-gray-600 text-center leading-relaxed">
        {partner.address}
      </p>
    </div>
  );
};

export default PartnerCard;
